import React from 'react';
import PropTypes from 'prop-types';
import {
    Card,
} from 'react-bootstrap';
import {
    Icon,
} from '@iconify/react';
import phoneIcon from '@iconify/icons-mdi/phone';
import emailOutline from '@iconify/icons-mdi/email-outline';
import webIcon from '@iconify/icons-mdi/web';
import businessIcon from '@iconify/icons-mdi/business';

const undefinedIfEmpty = (val) => val && String(val).length ? String(val) : undefined;

export default class ContactDetails extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        contact: PropTypes.any,
    }

    render() {
        const contact = this.props.contact;
        if (!contact) {
            return null;
        }
        const contactProfile = undefinedIfEmpty(contact.get('profile'));
        const contactFirstname = contact.get('firstname');
        const contactLastname = contact.get('lastname');
        let name = ((contactFirstname || '') + ' ' + (contactLastname || '')).trim();
        name = name.length ? name : false;
        const contactCompany = undefinedIfEmpty(contact.get('company'));
        const contactZip = undefinedIfEmpty(contact.get('zip'));
        const contactCity = undefinedIfEmpty(contact.get('city'));
        const contactStreet = undefinedIfEmpty(contact.get('street'));
        let contactAddress = (
            (contactStreet ? contactStreet + ',' : '') + ' ' +
            (contactZip || '') + ' ' + (contactCity || '')
        ).trim();
        contactAddress = contactAddress.length ? contactAddress : false;
        const contactMail = undefinedIfEmpty(contact.get('email'));
        const contactPhone = undefinedIfEmpty(contact.get('phone'));
        const contactWeb = undefinedIfEmpty(contact.get('web'));

        return (
            <Card className={`${this.props.className} p-2`}>
                <div
                    style={{
                        display: 'flex',
                        flex: '1 1 auto',
                        alignItems: 'center',
                    }}
                >
                    {contactProfile &&
                    <div className="img-square-wrapper">
                        <img className="" src={contactProfile}/>
                    </div>
                    }
                    <Card.Body
                        className={'text-left p-0 pl-3'}
                    >
                        {name &&
                        <h4 className="m-1">{name}</h4>
                        }

                        <small>
                            {contactCompany &&
                            <div className="contact-item">
                                <Icon icon={businessIcon} width="1em"/>
                                <span>{contactCompany + ' / ' + contactAddress}</span>
                                <br/>
                            </div>
                            }
                            {contactPhone &&
                            <div className="contact-item">
                                <Icon icon={phoneIcon} width="1em"/>
                                <span>
                                    <a className="m-0 p-0" href={"callto:" + contactPhone}>{contactPhone}</a>
                                </span>
                                <br/>
                            </div>
                            }
                            {contactMail &&
                            <div className="contact-item">
                                <Icon icon={emailOutline} width="1em"/>
                                <span>
                                    <a className="m-0 p-0" href={"mailto:" + contactMail}>{contactMail}</a>
                                </span>
                                <br/>
                            </div>
                            }
                            {contactWeb &&
                            <div className="contact-item">
                                <Icon icon={webIcon} width="1em"/>
                                <span>
                                    <a className="m-0 p-0" href={contactWeb}>{contactWeb}</a>
                                </span>
                            </div>
                            }
                        </small>
                    </Card.Body>
                </div>
            </Card>
        );
    }
}
